import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box, IconButton, makeStyles, Typography } from '@material-ui/core';
import { CustomIcon } from '../index';

export const getCloseButtonId = id => `${id}-close`;

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '300px',
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 4,
    boxSizing: 'border-box'
  },
  success: {
    background: theme.palette.primary.main
  },
  error: {
    background: theme.palette.warning.dark
  },
  warning: {
    background: theme.palette.warning.light
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: theme.palette.primary.contrastText,
    margin: `0 ${theme.spacing(1)}px`
  },
  closeButtonContainer: {
    flexShrink: 0,
    position: 'relative',
    margin: 'auto 0 auto auto',
    width: theme.spacing(3.5),
    height: theme.spacing(3)
  },
  closeButton: {
    position: 'absolute',
    left: -theme.spacing(0.5),
    top: -theme.spacing(0.5),
    padding: theme.spacing(0.5)
  }
}));

const iconMap = {
  success: 'confirm',
  error: 'alert',
  warning: 'questionIcon'
};

const Notification = React.forwardRef(
  ({ id, className, type, title, onCloseClick, children }, ref) => {
    const classes = useStyles();

    return (
      <Box
        ref={ref}
        role="alert"
        id={id}
        className={classNames(classes.root, classes[type], className)}
        data-notification-type={type}
      >
        <CustomIcon
          icon={iconMap[type]}
          size="small"
          variant="primaryContrast"
        />
        <Box className={classes.content}>
          <Typography component="h3" variant="body1">
            {title}
          </Typography>
          {children}
        </Box>
        <Box className={classes.closeButtonContainer}>
          <IconButton
            id={getCloseButtonId(id)}
            className={classes.closeButton}
            onClick={onCloseClick}
            data-notification-close
          >
            <CustomIcon
              icon="dismissIcon"
              size="small"
              variant="primaryContrast"
            />
          </IconButton>
        </Box>
      </Box>
    );
  }
);

Notification.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(['error', 'warning', 'success']),
  title: PropTypes.string,
  onCloseClick: PropTypes.func,
  children: PropTypes.any
};

export default Notification;
